import _classCallCheck from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import { __rest as o } from "../_virtual/_tslib.js";
import { jsx as e } from "react/jsx-runtime";
import { Component as t } from "react";
import { calculateRem as r } from "@vds-core/utilities";
import { ButtonIcon as i } from "@vds-core/button-icons";
import n from "@vds-core/icons/close";
import s from "styled-components";
import { ColorTokens as a } from "@vds-tokens/color";
var c = s.div.withConfig({
  displayName: "IconWrapper",
  componentId: "VDS__sc-m1up5c-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  width: ", ";\n  height: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1;\n  background-color: ", ";\n"])), r(48), r(48), function (_ref) {
  var o = _ref.surface,
    e = _ref.viewport;
  return "mobile" === e ? "dark" === o ? a.background.primary.dark.value : a.background.primary.light.value : "";
});
var d = /*#__PURE__*/function (_t) {
  _inherits(d, _t);
  function d() {
    _classCallCheck(this, d);
    return _possibleConstructorReturn(this, _getPrototypeOf(d).apply(this, arguments));
  }
  _createClass(d, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var o = "undefined" != typeof document ? document.getElementById("modal-close-button") : null;
      this.props.hovered && o && setTimeout(function () {
        o.blur();
      }, 0);
    }
  }, {
    key: "render",
    value: function render() {
      var t = this.props.ariaLabel ? "".concat(this.props.ariaLabel, " close") : "Close",
        r = this.props,
        s = r.toggleButton,
        a = r.isAppleDevice,
        d = r.closeButtonFocusBorderRadius,
        u = r.borderRadius,
        l = r.unmounted,
        p = r.hovered,
        m = r.isKeyboardInteraction,
        b = r.scrollbarId,
        f = r.onKeyDown,
        v = r.surface,
        g = r.viewport,
        h = o(r, ["toggleButton", "isAppleDevice", "closeButtonFocusBorderRadius", "borderRadius", "unmounted", "hovered", "isKeyboardInteraction", "scrollbarId", "onKeyDown", "surface", "viewport"]);
      return e(c, {
        surface: v,
        viewport: g,
        children: e(i, Object.assign({}, h, {
          kind: "ghost",
          size: "small",
          renderIcon: function renderIcon(o) {
            return e(n, Object.assign({}, o));
          },
          tabIndex: 0,
          id: this.props.id,
          ariaLabel: t,
          "data-testid": "modal-close-button",
          onKeyDown: f
        }))
      });
    }
  }]);
  return d;
}(t);
export { d as default };